var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"Icon",class:[
    _vm.tone ? _vm.variationName('tone', _vm.tone) : '',
    _vm.rotate ? _vm.variationName('rotate', _vm.rotate) : '',
  ]},[(_vm.accessibilityLabel)?_c('p-text',{attrs:{"as":"span","visuallyHidden":""}},[_vm._v(" "+_vm._s(_vm.accessibilityLabel)+" ")]):_vm._e(),_vm._t("default",function(){return [_c(_vm.svg,{tag:"div"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }